export const TOGGLE_SEARCH_DIALOG = 'TOGGLE_SEARCH_DIALOG'

export const LOAD_MORE_SEARCH_RESULTS_REQUEST = 'LOAD_MORE_SEARCH_RESULTS_REQUEST'
export const LOAD_MORE_SEARCH_RESULTS_SUCCESSFUL = 'LOAD_MORE_SEARCH_RESULTS_SUCCESSFUL'
export const LOAD_MORE_SEARCH_RESULTS_ERROR = 'LOAD_MORE_SEARCH_RESULTS_ERROR'

export const SEARCH_QUERY_CHANGED = 'SEARCH_QUERY_CHANGED'
export const FETCH_SEARCH_RESULTS_REQUEST = 'FETCH_SEARCH_RESULTS_REQUEST'
export const FETCH_SEARCH_RESULTS_SUCCESSFUL = 'FETCH_SEARCH_RESULTS_SUCCESSFUL'
export const FETCH_SEARCH_RESULTS_ERROR = 'FETCH_SEARCH_RESULTS_ERROR'

export const searchQueryChanged = (query, executeSearch=true) => {
    return {type: SEARCH_QUERY_CHANGED, payload: {...query, executeSearch}}
}

export const loadMoreSearchResults = () => {
    return {type: LOAD_MORE_SEARCH_RESULTS_REQUEST}
}

export const toggleSearchDialog = () => {
    return {type: TOGGLE_SEARCH_DIALOG}
}



// WEBPACK FOOTER //
// ./src/actions/search.js